




































import CommandDisplay from '@/components/CommandDisplay.vue';
import IMessage from '@/interfaces/message';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {
    CommandDisplay,
  },
})
export default class MessageDisplay extends Vue {
  @Prop({ required: true })
  public message!: IMessage;

  @Prop({ required: false })
  public hideDevice?: boolean;

  @Prop({ required: false })
  public showMoreInfo?: boolean;

  @Prop({ required: false })
  public deviceId?: string;

  public showDeviceMessages(deviceId: string) {
    this.$router.push('/device/' + deviceId);
  }
}
